module.exports = __webpack_public_path__ + "static/media/1.194e0874.jpg";